import * as THREE from 'three';

export default class HighlightSphere extends THREE.Mesh
{
	static tempPosition = new THREE.Vector3();
	static tempRotation = new THREE.Quaternion();
	static tempScale = new THREE.Vector3();

	sphereScale: number;

	constructor(sphereGeometry: THREE.BufferGeometry, sphereMaterial : THREE.Material)
	{
		super(sphereGeometry, sphereMaterial);
		this.userData.hideInHierarchy = true;
		this.userData.ignoreExport = true;
		this.sphereScale = 1;
	}

	updateMatrixWorld(force: boolean)
	{
		super.updateMatrixWorld(force);
		this.matrixWorld.decompose(HighlightSphere.tempPosition, HighlightSphere.tempRotation, HighlightSphere.tempScale);
		HighlightSphere.tempScale.set(this.sphereScale, this.sphereScale, this.sphereScale);
		this.matrixWorld.compose(HighlightSphere.tempPosition, HighlightSphere.tempRotation, HighlightSphere.tempScale);
	}

	setScale(value: number)
	{
		this.sphereScale = value;
	}

	clone(recursive = false) : any
	{
		const emptyObject = new THREE.Object3D();
		emptyObject.userData.hideInHierarchy = true;
		emptyObject.userData.ignoreExport = true;
		emptyObject.name ="highlightsphere_copy_debug_name";
		return emptyObject;
	}
}